<p-dialog
  header="Notification Settings"
  [modal]="true"
  [position]="'top'"
  [resizable]="false"
  [draggable]="false"
  appendTo="body"
  [(visible)]="viewSettingsModal"
  (onHide)="onHideSettingDailog()"
  [style]="{
    width: '40%',
    'border-radius': '10px',
    overflow: 'visible',
  }">
  <ng-template pTemplate="content">
    <div
      class="p-fluid p-dir-col pt-3 px-3"
      [formGroup]="notificationSettingForm">
      <p-tabs value="0">
        <p-tablist>
          <p-tab value="0">Internal</p-tab>
          <p-tab value="1">Client</p-tab>
          <p-tab value="2">Chat</p-tab>
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel value="0">
            <p-tabs value="a">
              <p-tablist>
                <p-tab value="a">Workflow Owner</p-tab>
                <p-tab value="b">Co Owner</p-tab>
              </p-tablist>
              <p-tabpanels>
                <p-tabpanel value="a">
                  <div formGroupName="workflowOwnerSettings">
                    <div class="row">
                      <div class="col mb-3">
                        <div
                          class="form-check d-flex align-items-end gap-1 p-0">
                          <p-checkbox
                            inputId="check1"
                            formControlName="shippingEmail" />
                          <label class="form-check-label" for="check1">
                            Shipping
                          </label>
                        </div>
                      </div>
                      <div class="col">
                        <a
                          class="link"
                          (click)="
                            showUpdateEmailTemplate(
                              EnumRecipentsType.BC,
                              EnumPackageStatusType.Shipping
                            )
                          "
                          >Modify Template</a
                        >
                      </div>
                    </div>
                    <div class="row">
                      <div class="col mb-3">
                        <div
                          class="form-check d-flex align-items-end gap-1 p-0">
                          <p-checkbox
                            inputId="check2"
                            formControlName="transitEmail" />
                          <label class="form-check-label" for="check2">
                            In-Transit
                          </label>
                        </div>
                      </div>
                      <div class="col">
                        <a
                          class="link"
                          (click)="
                            showUpdateEmailTemplate(
                              EnumRecipentsType.BC,
                              EnumPackageStatusType.Transit
                            )
                          "
                          >Modify Template</a
                        >
                      </div>
                    </div>
                    <div class="row">
                      <div class="col mb-3">
                        <div
                          class="form-check d-flex align-items-end gap-1 p-0">
                          <p-checkbox
                            inputId="check3"
                            formControlName="deliveryEmail" />
                          <label class="form-check-label" for="check3">
                            Delivery
                          </label>
                        </div>
                      </div>
                      <div class="col">
                        <a
                          class="link"
                          (click)="
                            showUpdateEmailTemplate(
                              EnumRecipentsType.BC,
                              EnumPackageStatusType.Delivery
                            )
                          "
                          >Modify Template</a
                        >
                      </div>
                    </div>
                    <div class="row">
                      <div class="col mb-3">
                        <div
                          class="form-check d-flex align-items-end gap-1 p-0">
                          <p-checkbox
                            inputId="check4"
                            formControlName="exceptionEmail" />
                          <label class="form-check-label" for="check4">
                            Exception
                          </label>
                        </div>
                      </div>
                      <div class="col">
                        <a
                          class="link"
                          (click)="
                            showUpdateEmailTemplate(
                              EnumRecipentsType.BC,
                              EnumPackageStatusType.Exception
                            )
                          "
                          >Modify Template</a
                        >
                      </div>
                    </div>
                  </div>
                </p-tabpanel>
                <p-tabpanel value="b" formGroupName="coOwnerSettings">
                  <div class="row">
                    <div class="col mb-3">
                      <div class="form-check d-flex align-items-end gap-1 p-0">
                        <p-checkbox
                          inputId="check5"
                          formControlName="shippingEmail" />
                        <label class="form-check-label" for="check5">
                          Shipping
                        </label>
                      </div>
                    </div>
                    <div class="col">
                      <a
                        class="link"
                        (click)="
                          showUpdateEmailTemplate(
                            EnumRecipentsType.BAC,
                            EnumPackageStatusType.Shipping
                          )
                        "
                        >Modify Template</a
                      >
                    </div>
                  </div>
                  <div class="row">
                    <div class="col mb-3">
                      <div class="form-check d-flex align-items-end gap-1 p-0">
                        <p-checkbox
                          inputId="check6"
                          formControlName="transitEmail" />
                        <label class="form-check-label" for="check6">
                          In-Transit
                        </label>
                      </div>
                    </div>
                    <div class="col">
                      <a
                        class="link"
                        (click)="
                          showUpdateEmailTemplate(
                            EnumRecipentsType.BAC,
                            EnumPackageStatusType.Transit
                          )
                        "
                        >Modify Template</a
                      >
                    </div>
                  </div>
                  <div class="row">
                    <div class="col mb-3">
                      <div class="form-check d-flex align-items-end gap-1 p-0">
                        <p-checkbox
                          inputId="check7"
                          formControlName="deliveryEmail" />
                        <label class="form-check-label" for="check7">
                          Delivery
                        </label>
                      </div>
                    </div>
                    <div class="col">
                      <a
                        class="link"
                        (click)="
                          showUpdateEmailTemplate(
                            EnumRecipentsType.BAC,
                            EnumPackageStatusType.Delivery
                          )
                        "
                        >Modify Template</a
                      >
                    </div>
                  </div>
                  <div class="row">
                    <div class="col mb-3">
                      <div class="form-check d-flex align-items-end gap-1 p-0">
                        <p-checkbox
                          inputId="check8"
                          formControlName="exceptionEmail" />
                        <label class="form-check-label" for="check8">
                          Exception
                        </label>
                      </div>
                    </div>
                    <div class="col">
                      <a
                        class="link"
                        (click)="
                          showUpdateEmailTemplate(
                            EnumRecipentsType.BAC,
                            EnumPackageStatusType.Exception
                          )
                        "
                        >Modify Template</a
                      >
                    </div>
                  </div>
                </p-tabpanel>
              </p-tabpanels>
            </p-tabs>
          </p-tabpanel>
          <p-tabpanel value="1" formGroupName="clientSettings">
            <div class="row">
              <div class="col mb-3">
                <div class="form-check d-flex align-items-end gap-1 p-0">
                  <p-checkbox
                    inputId="check13"
                    formControlName="shippingEmail" />
                  <label class="form-check-label" for="check13">
                    Shipping
                  </label>
                </div>
              </div>
              <div class="col">
                <a
                  class="link"
                  (click)="
                    showUpdateEmailTemplate(
                      EnumRecipentsType.Client,
                      EnumPackageStatusType.Shipping
                    )
                  "
                  >Modify Template</a
                >
              </div>
            </div>
            <div class="row">
              <div class="col mb-3">
                <div class="form-check d-flex align-items-end gap-1 p-0">
                  <p-checkbox
                    inputId="check14"
                    formControlName="transitEmail" />
                  <label class="form-check-label" for="check14">
                    In-Transit
                  </label>
                </div>
              </div>
              <div class="col">
                <a
                  class="link"
                  (click)="
                    showUpdateEmailTemplate(
                      EnumRecipentsType.Client,
                      EnumPackageStatusType.Transit
                    )
                  "
                  >Modify Template</a
                >
              </div>
            </div>
            <div class="row">
              <div class="col mb-3">
                <div class="form-check d-flex align-items-end gap-1 p-0">
                  <p-checkbox
                    inputId="check15"
                    formControlName="deliveryEmail" />
                  <label class="form-check-label" for="check15">
                    Delivery
                  </label>
                </div>
              </div>
              <div class="col">
                <a
                  class="link"
                  (click)="
                    showUpdateEmailTemplate(
                      EnumRecipentsType.Client,
                      EnumPackageStatusType.Delivery
                    )
                  "
                  >Modify Template</a
                >
              </div>
            </div>
            <div class="row">
              <div class="col mb-3">
                <div class="form-check d-flex align-items-end gap-1 p-0">
                  <p-checkbox
                    inputId="check16"
                    formControlName="exceptionEmail" />
                  <label class="form-check-label" for="check16">
                    Exception
                  </label>
                </div>
              </div>
              <div class="col">
                <a
                  class="link"
                  (click)="
                    showUpdateEmailTemplate(
                      EnumRecipentsType.Client,
                      EnumPackageStatusType.Exception
                    )
                  "
                  >Modify Template</a
                >
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 form-group has-float-label">
                <label class="form-label px-2">Recepient Emails</label>
                <input
                  pInputText
                  jniAutoCompleteBlocker
                  class="form-control"
                  type="text"
                  formControlName="clientEmailRecipients" />
              </div>
            </div>
          </p-tabpanel>
          <p-tabpanel value="2">
            <div class="col mb-3">
              <div class="form-check d-flex align-items-end gap-1 p-0">
                <p-checkbox
                  inputId="check17"
                  formControlName="chatEmailEnabled" />
                <label class="form-check-label" for="check17">
                  Disable Email Notification for Chat
                </label>
              </div>
            </div>
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="d-flex pt-3 justify-content-end has-sticky gap-3">
      <!-- <p-button
        type="button"
        class="btn btn-secondary me-3"
        (click)="closeModal()">
        Cancel
      </p-button>
      <p-button
        type="button"
        class="btn btn-primary"
        (click)="updateNotificationSettings()">
        Update
      </p-button> -->

      <p-button
        label="Cancel"
        (click)="closeModal()"
        variant="outlined"
        severity="secondary" />

      <p-button label="Update" (click)="updateNotificationSettings()" />
    </div>
  </ng-template>
</p-dialog>

<jni-notification-email-setting
  *ngIf="viewUpdateEmailTemplateModal"
  [viewEmailSettingsModal]="viewUpdateEmailTemplateModal"
  (closeModalEvent)="closeEmailUpdateModal()"
  [notificationEmailData]="workflowEmailDetails"
  (updateEmailDataEvent)="updateEmailNotificationSettings($event)"
  (hasUnsavedChangesEvent)="onEmailInputChanges($event)">
</jni-notification-email-setting>
